type Level = 'error' | 'warn' | 'info' | 'debug'

const LEVELS: Record<Level, number> = { error: 0, warn: 1, info: 2, debug: 3 }
const CURRENT = ((import.meta.env.VITE_LOG_LEVEL ?? 'info') as Level).toLowerCase() as Level
const ALLOW = LEVELS[CURRENT] ?? 2

type AnyObj = unknown

export const Logger = {
  level: CURRENT,
  newRequestId(): string {
    return (
      globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`
    )
  },
  debug(msg: string, obj?: AnyObj) { if (ALLOW >= 3) console.debug(`[DEBUG] ${msg}`, obj ?? '') },
  info (msg: string, obj?: AnyObj) { if (ALLOW >= 2) console.info (`[INFO] ${msg}`, obj ?? '') },
  warn (msg: string, obj?: AnyObj) { if (ALLOW >= 1) console.warn (`[WARN] ${msg}`, obj ?? '') },
  error(msg: string, obj?: AnyObj) {                 console.error(`[ERROR] ${msg}`, obj ?? '') }
}
